import SocialProofSlider from './SocialProofSlider';
import Image from 'next/image';
import { getStack } from '@/lib/contentstack/stack';

export default async function SocialProof({ block, position }) {
  const { background_color_picker, proof, _metadata } =
    await block.social_proof;

  const { uid } = _metadata;

  return (
    <section
      id={uid + '_' + position}
      data-name="social-proof"
      className={`block pt-0 pb-22 sm:pt-15 sm:pb-15 lg:mx-4 bg-[${background_color_picker}]`}
    >
      <SocialProofSlider
        componentID={uid + '_' + position}
        count={proof.length}
      >
        {proof.map((item, index) => {
          const obj = {
            uid: item.proof_image.uid,
            title: item.proof_title,
            image: {
              title: item.proof_image.title,
              url: item.proof_image.url,
              alt: item.proof_image_alt_copy,
              height: item.proof_image.dimension.height,
              width: item.proof_image.dimension.width
            },
            copyOne: item.proof_copy_one,
            copyTwo: item.proof_copy_two
          };

          const imageRatio = obj.image.height / 56;

          return (
            <li key={`social-proof-slide-${index}`}>
              <div
                data-count={index}
                className="flex h-full flex-col justify-between"
              >
                <div className="social-proof-img-wrapper my-4 max-[524px]:mt-6 max-[524px]:mb-3">
                  <Image
                    id={uid + '_' + obj.uid}
                    src={obj.image.url}
                    alt={obj.image.alt}
                    width={obj.image.width}
                    height={obj.image.height}
                    sizes="123px"
                    style={{
                      width: `${obj.image.width / imageRatio}px`,
                      height: 'auto'
                    }}
                    className="mx-auto"
                  />
                </div>
                <div className="social-proof-content-wrapper body-s sm:body-r text-center">
                  {obj.copyOne}
                  <br />
                  {obj.copyTwo}
                </div>
              </div>
            </li>
          );
        })}
      </SocialProofSlider>
    </section>
  );
}

export async function fetchImage(image_uid) {
  const assetUid = image_uid;
  const Stack = getStack();
  const query = Stack.ContentType('assets').Entry(assetUid);
  const response = await query.fetch();
  const entry = response[0][0];

  const document = {
    locale: entry.locale,
    blocks: entry.modular_blocks,
    seo: entry.seo,
    tags: entry.tags,
    uid: entry.uid,
    updated_at: entry.updated_at,
    url: entry.url
  };

  return {
    props: {
      document
    }
  };
}
